import {country_code} from "@/utils/constants.ts";
import GenSettingsInterface from "@/types_and_interfaces/gen_settings_interface.ts";
import {SendDocType} from "@/types_and_interfaces/types.ts";
import moment from "moment";

class CommonClass {
    
    static init_auth: boolean = false
    
    static payment_methods_obj: any = undefined
    
    static local_storage_fields = {
        "device_uid":"device_uid",
        "login_data": "login_data",
        "have_logged_data": "have_logged_data",
        "session_token":"session_token",
        "back_url":"back_url",
        "resend_interval": "resend_interval",
        "apply_credit_form_body": "apply_credit_form_body",
        "cr_line_apply": "cr_line_apply",
        "page_proms_ts": "page_proms_ts",
        "on_enter_proms_ts": "on_enter_proms_ts",
        "on_page_proms_ts": "on_page_proms_ts",
        "edit_email_otp_interval": "edit_email_otp_interval",
        "edit_phone_otp_interval": "edit_phone_otp_interval",
        "login_back_interval": "login_back_interval",
        "loan_sidebar_data":"loan_sidebar_data",
        "sign_contract_otp_interval": "sign_contract_otp_interval",
        "prev_path":"prev_path",
        "reserve_data": "reserve_data",
        "before_apply_cr": "before_apply_cr",
        "session_calculator_values": "session_calculator_values",
        "i18nextLng":"i18nextLng",
        "refresh_interval": "refresh_interval",
        "check_phone_data": "check_phone_data",
        "login_kyc_checking_active": "login_kyc_checking_active",

    }
    
    static basic_routes:any = {
        "become_partner": "/become-partner",
        "contact": "/contact"
    }
    
    static api_routes = {
        "Login":"/login"
    }
    
    static fetch_methods = {
        "Post": "POST",
        "Get":"GET"
    }
    
    static public_paths = {
        "payment_methods": "/images/payment_methods",
        "common_images":"/images/common",
        "cms_download_app":"/images/cms_elems/download_app_block",
        "dashboard":"/images/dashboard"
    }
    
    static CustomEvents = {
        "set_req_load":"set_req_load",
        "set_err":"set_err",
        "set_err_otp":"set_err_otp",
        "set_err_pwd":"set_err_pwd",
        "set_recaptcha_token":"set_recaptcha_token",
        "set_map_location":"set_map_location",
        "redirect_to": "redirect_to",
        "set_loading_screen": "set_loading_screen",
        "set_resend_interval": "set_resend_interval",
        "upd_notifications": "upd_notifications",
        "upd_loans": "upd_loans",
        "logout": "logout",
        "switch_doc_reader": "switch_doc_reader",
        "update_snackbar": "update_snackbar",
        "update_popping_notifications": "update_popping_notifications",
        "remove_snackbar": "remove_snackbar",
        "show_promo_popups": "show_promo_popups",
        "set_edit_profile_load": "set_edit_profile_load",
        "reset_otp_value": "reset_otp_value",
        "reset_pwd_value": "reset_pwd_value",
        "no_connection_listener_show": "no_connection_listener_show",
        "session_expired": "session_expired",
        "server_time_not_good": "server_time_not_good",
        "clear_states": "clear_states",
        "ttl_modal_open": "ttl_modal_open",
        "reset_states": "reset_states",
        "upd_popup_notifs": "upd_popup_notifs",
        "notification_sidebar_handle": "notification_sidebar_handle",
        "open_schedule": "open_schedule",
        "loading_schedule": "loading_schedule",
        "remove_contract": "remove_contract",
        "clear_build_interval": "clear_build_interval",
        "show_refresh": "show_refresh",
        "phoneSet":"phoneSet",
        "set_pwd_err_text":"set_pwd_err_text",
        "set_pin_err_text":"set_pin_err_text",
        "reset_counter":"reset_counter"
    }
    
    static ModalEvents =  {
        "CrApplyedDiffNumber": "CrApplyedDiffNumber",
        "GoToKYC": "GoToKYC",
        "PromoSubscribe":"PromoSubscribe",
        "SignContractErr":"SignContractErr",
        "SetEmail":"SetEmail",
        "SetPhone": "SetPhone",
        "SetCRInfo": "SetCRInfo",
        "OpenCalculator": "OpenCalculator",
        "OpenAddNotifModal": "OpenAddNotifModal",
        "OpenGetContractModal": "OpenGetContractModal",
        "PayCreditModalOpen": "PayCreditModalOpen",
        "BuildVersionModalOpen": "BuildVersionModalOpen",
        "FocusInputs": "FocusInputs",
        "OpenDataConsent": "OpenDataConsent"
    }
    
    static breakpoints = {
        "breakpoint1": 1440,
        "breakpoint2": 1150,
        "breakpoint3": 830
    }
    
    static js_channels = {
        "kyc_priority": "kyc_priority"
    }

    static general_settings:GenSettingsInterface | any = {}
    static sentry_user:any = undefined

    static isEmailValid = (email: string): boolean => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };
    
    static resetInput = (input_name:string) => {
        const input:any = document.querySelector(`[name="${input_name}"]`);

        if(input) {
            input.value = ""
        }
    }
    
    static formatNumber = (nr:string) => {
        let formattedNumber = nr.replace(/\D/g, '');
        if (formattedNumber.startsWith('0')) {
            formattedNumber = formattedNumber.substring(1);
        }
        if (formattedNumber.length > 2) {
            formattedNumber = formattedNumber.replace(/(\d{3})(\d{2})(\d{3})/, '$1 $2 $3');
        }
        
        if (formattedNumber.length <= 10) {
            return formattedNumber
        }
        
        return formattedNumber.slice(0, 10)
    }
    
    static formatIban(input: string, limit: number = 16): string {
        const inputNumber = input.replace(/\D/g, '');
        let formattedNumber = '';
        
        for (let i = 0; i < inputNumber.length && i < limit; i++) {
            if (i > 0 && i % 4 === 0) {
                formattedNumber += ' ';
            }
            formattedNumber += inputNumber[i];
        }
        
        return formattedNumber.trim();
    }
    
    static removeHTMLString(text:string):string {
        return text.replace(/<[^>]*>/g, '') || ""
    }
    
    static handleScrollToTop () {
        if(typeof window === "undefined") return;
        
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };
    
    static formatMoneyAmount = (nr:number) => {
        return nr?.toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    
    static navigateTo = (page:string) => {
        const currentURLRoot = window?.location.origin;
        const go_to_url = `${currentURLRoot}${page}`;
        window.open(go_to_url, '_self');
    }
    
    static phoneFormater = (phone: string) => {
        let ph = ""
        
        phone.split("").map((ch) => {
            if(ch !== " "){
                ph += ch
            }
        })
        
        return `${country_code}${ph}`
    }

    static get_credit_end_by_installments = (from:string, inst: number) => {
        const cr_date = new Date(from)
        cr_date.setMonth(cr_date.getMonth() + inst);

    }
    
    static phoneNumberValidate = (phone: string) => {
        let validate: boolean = false;

        const mobile_destination_code = [
            "60",
            "61",
            "62",
            "66",
            "67",
            "68",
            "69",
            "76",
            "77",
            "78",
            "79",
        ];

        if (mobile_destination_code.includes(phone.slice(0, 2)) && phone.length === 10) {
            validate = true;
        }

        return validate;
    };

    // Validates phone in full format with country code prefix (e.g., +37368040725)
    static phoneNumberValidateFull = (phone: string) => {
        const mobile_destination_code = [
            "60", "61", "62", "66", "67", "68", "69",
            "76", "77", "78", "79",
        ];

        // Check if starts with country code
        if (!phone.startsWith(country_code)) {
            return false;
        }

        // Remove country code and check the rest
        const phoneWithoutCode = phone.replace(country_code, "");

        // Should be 8 digits, starting with valid mobile code
        if (phoneWithoutCode.length !== 8) {
            return false;
        }

        return mobile_destination_code.includes(phoneWithoutCode.slice(0, 2));
    };

    static validateIDNX = (idnx:string):any => {
        
        let response = {
            validate: false,
            type: ""
        }
        
        if(!idnx.length) return false
        

        let is_idnp = idnx[0] === "0" || idnx[0] === "2"
        let is_idno = !is_idnp
        
        if(is_idnp) {
            const re = new RegExp("^[02]\\d{12}$");
            response.type = "idnp"
            
            if(re.test(idnx) || idnx.length === 13) {
                response.validate = true
            } else return response
        }

        if(is_idno) {
            const re = new RegExp("^(1\\d{12})$");
            response.type = "idno"
            
            if(re.test(idnx) || idnx.length === 13 ) {
                response.validate = true
            } else return response
        }
        
        if(idnx.length === 13) {
            let re = new RegExp('^([012]\\d{12})$');
            
            if(!re.test(idnx)){
                response.validate = false
                return response
            }

            //invalidate 13 zeros, also 11 zeros and last digits 11,22,33...,88,99
            if(/^0{13}$|^0{11}(\d)\1$/.test(idnx)){
                response.validate = false
                return response
            }

            const mask = new String("731731731731");
            const control_digit_nr = 12;
            let total = 0;
            let remainder = 0
            
            for (let i = 0; i < mask.length; i++) {
                try {
                    total = total + parseInt(idnx.charAt(i)) * parseInt(mask.charAt(i));
                } catch (e) {
                    response.validate = false
                    return response;
                }
            }
            
            remainder = total % 10;
            
            if (remainder == parseInt(idnx.charAt(control_digit_nr))) {
                response.validate = true
                return response
            } else {
                response.validate = false
                return response
            }
        }
        
        return response
    }
    
    static convertCoordinatesToLatLng = (coordinateString:string) => {
        const regex = /^(\d+)°(\d+)'([\d.]+)"([NS]) (\d+)°(\d+)'([\d.]+)"([EW])$/;
        const matches = coordinateString.match(regex);
        
        if (!matches) return {
            lat: 47.023,
            lng: 28.842
        }
        
        const latDegrees = parseFloat(matches[1]);
        const latMinutes = parseFloat(matches[2]);
        const latSeconds = parseFloat(matches[3]);
        const latDirection = matches[4];
        
        const lngDegrees = parseFloat(matches[5]);
        const lngMinutes = parseFloat(matches[6]);
        const lngSeconds = parseFloat(matches[7]);
        const lngDirection = matches[8];
        
        const latDecimal = latDegrees + (latMinutes / 60) + (latSeconds / 3600);
        const lngDecimal = lngDegrees + (lngMinutes / 60) + (lngSeconds / 3600);
        
        return {
            lat: latDirection === 'S' ? -latDecimal : latDecimal,
            lng: lngDirection === 'W' ? -lngDecimal : lngDecimal,
        };
    }
    
    static convertLocationToId = (x:string):string => {
        return x.replace(/\D/g, "");
    }
    
    static calculateTimeSince = (timestamp:number) => {
        
        const now = Date.now();
        const diff = now - timestamp;
        
        const minute = 60 * 1000;
        const hour = 60 * minute;
        const day = 24 * hour;
        const week = 7 * day;
        const month = 30 * day;
        const year = 365 * day;
        
        if (diff < minute) {
            return { unit: 'minute', quantity: 1 };
        } else if (diff < hour) {
            const minutes = Math.floor(diff / minute);
            return { unit: minutes === 1 ? 'minute' : minutes > 1 && minutes < 5 ? 'minutes' : "minutes1", quantity: minutes };
        } else if (diff < day) {
            const hours = Math.floor(diff / hour);
            return { unit: hours === 1 ? 'hour' : hours > 1 && hours < 5 ? 'hours' : 'hours1',  quantity: hours };
        } else if (diff < week) {
            const days = Math.floor(diff / day);
            return { unit: days === 1 ? 'day' : days > 1 && days < 5 ? 'days' : 'days2', quantity: days };
        } else if (diff < month) {
            const weeks = Math.floor(diff / week);
            return { unit: weeks === 1 ? 'week' : weeks > 1 && weeks < 5 ?  'weeks' : "weeks1", quantity: weeks };
        } else if (diff < year) {
            const months = Math.floor(diff / month);
            return { unit: months === 1 ? 'month' : months > 1 && months < 5 ? "months" : 'months1', quantity: months };
        } else {
            const years = Math.floor(diff / year);
            return { unit: years === 1 ? 'year' : years > 1 && years < 5 ? 'years' : "years1", quantity: years };
        }
        
    }

    static displayDayTime = (timestamp:number | string) => {
        return !!timestamp ? moment(timestamp).format('DD.MM.YYYY HH:mm:ss') : '';
    }

    static get_img_list = (event:any) => {
        const raw_img_list = event.detail.data.response.images.fieldList
        const needed_images = raw_img_list.find((x:any) => x.fieldName === "Document front side").valueList
        const cropped_images = needed_images.filter((x:any) => x.containerType === 1)
        let list:Array<any> = []

        cropped_images.map((x:any, i:number) => {
            list.push({
                "ImageData": {
                    "image": x.value
                },
                "light": x.lightIndex,
                "page_idx": i
            })
        })

        return list
    }

    static doc_reader_event_result = (event:any):SendDocType => {


        if(event.detail.action === 'PROCESS_FINISHED' && event.detail.data.status === 1) {
            return "processing"
        } else if(event.detail.action === 'PROCESS_FINISHED' && event.detail.data.status === 2) {
            return "timeout"
        } else if(event.detail.action === "VIDEO_STARTED") {
            return "init"
        } else if(event.detail.action === 'PROCESS_FINISHED' && event.detail.data.reason === "CAMERA_UNKNOWN_ERROR") {
            return "no_camera"
        } else if(event.detail.action === 'PROCESS_FINISHED' && event.detail.data.reason === "CAMERA_PERMISSION_DENIED") {
            return "camera_denied"
        } else if(event.detail.action === 'PROCESS_FINISHED' && event.detail.data.status === 0){
            return "init_error"
        }

        return ""
    }
    
    static days_till_prom_end = (pr:any):any => {
        
        if(pr.promo && typeof pr.promo_end_date === "string") {
            const currentDate = new Date();
            
            const targetDate = new Date(pr.promo_end_date);
            
            const differenceInMilliseconds = targetDate.getTime() - currentDate.getTime();
            
            const millisecondsPerDay = 1000 * 60 * 60 * 24;
            const millisecondsPerHour = 1000 * 60 * 60;
            
            const differenceInDays = Math.floor(differenceInMilliseconds / millisecondsPerDay);
            const differenceInHours = Math.floor((differenceInMilliseconds % millisecondsPerDay) / millisecondsPerHour);
            
            return {
                days: differenceInDays,
                hours: differenceInHours,
            }
        }
        
        return undefined
        
    }
    
    static date_plus_months = (added: number) => {
        const currentDate = new Date();
        
        const futureDate = new Date(currentDate);
        futureDate.setMonth(futureDate.getMonth() + added);
        
        const day = String(futureDate.getDate()).padStart(2, '0');
        const month = String(futureDate.getMonth() + 1).padStart(2, '0');
        const year = futureDate.getFullYear();
        
        const formattedDate = `${day}.${month}.${year}`;
        
        return formattedDate;
    }
    
    static convertAlpha(c:any) {
        switch (c) {
            case 'A': return 10;
            case 'B': return 11;
            case 'C': return 12;
            case 'D': return 13;
            case 'E': return 14;
            case 'F': return 15;
            case 'G': return 16;
            case 'H': return 17;
            case 'I': return 18;
            case 'J': return 19;
            case 'K': return 20;
            case 'L': return 21;
            case 'M': return 22;
            case 'N': return 23;
            case 'O': return 24;
            case 'P': return 25;
            case 'Q': return 26;
            case 'R': return 27;
            case 'S': return 28;
            case 'T': return 29;
            case 'U': return 30;
            case 'V': return 31;
            case 'W': return 32;
            case 'X': return 33;
            case 'Y': return 34;
            case 'Z': return 35;
            default: return parseInt(c); // For digits
        }
    }
    
    static longMod(stringNumber:any, divider:any) {
        let reminder = "";
        for (let i = 0; i < stringNumber.length; i++) {
            reminder += stringNumber[i];
            
            // @ts-ignore
            reminder = "" + reminder % divider;
            
        }
        return parseInt(reminder);
    }
    
    static check_iban(ibanCode:string) {
        const re = /^[A-Z]{2}\d{2}[A-Z0-9]{4}[0-9A-Z]{16}$/;
        const res = re.exec(ibanCode);
        if (!res) return false;
        
        const shift = ibanCode.substring(4) + ibanCode.substring(0, 4);
        let translate = "";
        for (let i = 0; i < shift.length; i++) {
            translate += this.convertAlpha(shift[i]);
        }
        
        return this.longMod(translate, 97) === 1;
    }
    
    static check_iban_by_bank = (iban:string, code:string):boolean => {
        let res = false
        const iban_sm_code = iban.slice(4,6)
        
        if(iban_sm_code === code) res = true
        
        return res
    }
    
    static denny_to_apply = (loans:any) => {
        if (
            loans.hasOwnProperty("pending_approval") ||
            loans.hasOwnProperty("unknown") ||
            loans.hasOwnProperty("pending_submission") ||
            loans.hasOwnProperty("submitting") ||
            loans.hasOwnProperty("approved_and_need_sign") ||
            loans.hasOwnProperty("approved_and_not_verified") ||
            loans.hasOwnProperty("more_data_and_not_verified") ||
            loans.hasOwnProperty("more_data_and_verified")
        ) {
            return true
        } else return false
    }
    
    // static time_word_handling = (d_number:number, months?:boolean) => {
    //
    //     switch (d_number) {
    //         case 1:
    //             return months ? "month" : "day";
    //         case 2:
    //         case 3:
    //         case 4:
    //             return months ? "months" : "days";
    //         default:
    //             return months ? "months1" : "days2";
    //     }
    // }
    
    static time_word_handling = (d_number: number, months?: boolean) => {
        
        if (d_number === 1) return months ? "month" : "day";
        
        if(d_number < 21) {
            if (d_number % 10 === 1 && d_number % 100 !== 11) {
                return months ? "month2" : "day1";
            }
            if ([2, 3, 4].includes(d_number % 10) && ![12, 13, 14].includes(d_number % 100)) {
                return months ? "months" : "days";
            }
            return months ? "months1" : "days2";
        } else {

            if (d_number % 10 === 1 && d_number % 100 !== 11) {
                return months ? "month211" : "day111";
            }

            if ([2, 3, 4].includes(d_number % 10) && ![12, 13, 14].includes(d_number % 100)) {
                return months ? "months11" : "days";
            }

            return months ? "months111" : "days211";
        }



    };

    static isOnlyRomanianOrEnglishChars = (text: string): boolean => {
        if (!text) return false;

        const allowedCharsRegex = /^[a-zA-Z0-9ăâîșşțţĂÂÎȘŞȚŢ\s.,!?'"()\-:;]+$/;

        return allowedCharsRegex.test(text);
    }

    static isSafeHtml = (html?: string): boolean => {
        if (!html) return false;

        const unsafePattern =
            /<script|on\w+\s*=|javascript:|<iframe|<object|<embed/i;

        return !unsafePattern.test(html);
    };
}

export default CommonClass